import styles from 'css/src/components/app/format-picker.module.scss';

import React from 'react';
import classNames from 'classnames';
import type { AspectRatio } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

const BACKUP_THUMBNAIL_URL = 'https://cdn.lumen5.com/lumen5-site-images/vancity.jpg';

type Props = {
    aspectRatio: AspectRatio;
    onClick: (aspectRatio: AspectRatio) => void;
    image_url?: string;
    selected?: boolean;
    className?: string;
};

const FormatOption = React.memo(function FormatOption({
    aspectRatio,
    onClick,
    image_url = BACKUP_THUMBNAIL_URL,
    selected,
    className,
}: Props) {
    const onClickInternal = React.useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault();
            onClick(aspectRatio);
        },
        [onClick, aspectRatio],
    );

    return (
        <div
            className={classNames(styles['format-option'], className, {
                [styles['selected']]: selected,
            })}
            onClick={onClickInternal}
        >
            <div className={classNames('card', styles['mockup-panel'])}>
                <div
                    className={classNames(styles['preview-image'], {
                        [styles['landscape']]: aspectRatio === 'landscape',
                        [styles['square']]: aspectRatio === 'square',
                        [styles['vertical']]: aspectRatio === 'vertical',
                        [styles['fourfive']]: aspectRatio === 'fourfive',
                    })}
                >
                    <div
                        className={styles['background-image']}
                        style={{ backgroundImage: `url("${image_url}")` }}
                    />
                </div>
                <div className="subtitle mt-l5-16 text-center">
                    <span className="mb-l5-8 font-l5 font-l5--h7">
                        {VideoData.getAspectRatioDisplayName(aspectRatio)}
                    </span>
                    <div className="text-muted font-l5 font-l5--subtitle-l mt-l5-8">
                        {VideoData.getAspectRatioDisplayRatio(aspectRatio)}&nbsp;ratio
                    </div>
                </div>
            </div>
        </div>
    );
});

export default FormatOption;
